import { CheckOutlined } from '@ant-design/icons';
import { Card, Col, Form, Image, InputNumber, Row, Space } from 'antd';
import Meta from 'antd/es/card/Meta';
import { useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import trapImageApi from '../../../../apis/TrapImageApi';
import { TrapImage } from '../../../../models/Entities';
import alertService from '../../../../services/AlertService';
import styles from './TrapImagesViewerImageComponent.module.scss';

/**
 * Returns the trap images viewer image component.
 * @returns the trap images viewer image component.
 */
const TrapImagesViewerImageComponent: React.FC<Props> = (props) => {
    const { trapImage: initalTrapImage } = props;

    /*** HOOKS ***/

    const intl = useIntl();
    const [form] = Form.useForm();
    const [trapImage, setTrapImage] = useState<TrapImage>(initalTrapImage);
    const [loading, setLoading] = useState<'saving'>();

    /*** EFFECTS ***/

    useEffect(() => {
        form.setFieldsValue(initalTrapImage);
    }, [form, initalTrapImage]);

    /*** METHODS ***/

    const save = async (values: any) => {
        try {
            if (values.insectsCount !== trapImage.insectsCount) {
                setLoading('saving');
                let updatedTrapImage = await trapImageApi.get(trapImage.id!);
                updatedTrapImage = Object.assign({}, updatedTrapImage, values);
                await trapImageApi.updateInsectsCount(updatedTrapImage.id!, updatedTrapImage);
                setTrapImage(updatedTrapImage);
            }
        } catch (error) {
            alertService.displayError(error, intl);
            setLoading(undefined);
        } finally {
            setTimeout(() => setLoading(undefined), 1000);
        }
    };

    /*** VISUAL ***/

    return (
        <Card cover={<Image src={trapImage.url} />} className={styles.container}>
            <Meta
                title={<FormattedDate value={trapImage.date as any} year="numeric" month="2-digit" day="2-digit" hour="2-digit" minute="2-digit" />}
                description={
                    <Form form={form} onFinish={save} colon={false} className={styles.counter}>
                        <Row gutter={[12, 12]} className={styles.counterRow}>
                            <Col span={24}>
                                <Space size={8}>
                                    <span className={styles.loader}>{loading === 'saving' && <CheckOutlined />}</span>
                                    <Form.Item name="insectsCount" className={styles.counterItem}>
                                        <InputNumber
                                            size="small"
                                            min={0}
                                            maxLength={3}
                                            controls={false}
                                            disabled={loading === 'saving'}
                                            onBlur={form.submit}
                                            onPressEnter={(e) => {
                                                e.preventDefault();
                                                form.submit();
                                            }}
                                            className={styles.inputNumber}
                                            bordered={true}
                                        />
                                    </Form.Item>

                                    <FormattedMessage id="trapImagesViewer.insects" />
                                </Space>
                            </Col>
                        </Row>
                    </Form>
                }
            />
        </Card>
    );
};
export default TrapImagesViewerImageComponent;

interface Props {
    trapImage: TrapImage;
}
